// api
import apiRequest from 'api/restapi';
import { AxiosResponse } from 'axios';

const postStory = (data: any): Promise<AxiosResponse<any>> => apiRequest.post('/RealStoryArticle', data);

export default { postStory };
